export default __webpack_public_path__ + "static/appercot-010970f2557857fdcbeddcfbdcd422bd.svg";